export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Solar',
            data: [0],
            backgroundColor: "rgba(34, 197, 94, 0.85)",
        },
        {
            label: 'Netzbezug',
            data: [0],
            backgroundColor: "rgba(251, 191, 36, 0.7)",
        }
    ]
};